import React, { useState } from "react";
import RegisterForm from "./RegisterForm"; // Подключаем форму регистрации

const Superadmin = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div style={styles.container}>
      {!showForm ? (
        <button style={styles.button} onClick={() => setShowForm(true)}>
          Зарегистрироваться
        </button>
      ) : (
        <RegisterForm />
      )}
    </div>
  );
};

const styles = {
  container: { textAlign: "center", marginTop: "50px" },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "white",
  },
};

export default Superadmin;
